// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3dqHq","overflowing":"ReadFullNote_overflowing__2JqYz"};